// extracted by mini-css-extract-plugin
export default {"title":"EditView_title__VTVP5","espacamento":"EditView_espacamento__XcgID"};